import { createFileRoute } from "@tanstack/react-router";
import { DossierDetailScreen } from "@modules/applications/views";
import { requireAnySurface } from "./-guards";

/**
 * /staff/rounds/$roundId/applications/$applicationId — a dossier's detail (Figma 09.11), reached
 * from any of the three list tables (Tous les dossiers / À traiter / Dossiers en attente).
 *
 * `applications_` (trailing underscore) escapes `staff.rounds_.$roundId.applications.tsx`'s own
 * component the same way `rounds_` escapes `staff/rounds.tsx` there — that screen is a leaf with
 * no `<Outlet/>`, so without this a deeper route would match (URL, breadcrumb) without ever
 * mounting. Same mechanism, one layer deeper.
 *
 * Gated on EITHER staff surface (2026-09-13) — same reasoning as the applications list this is
 * reached from.
 */
export const Route = createFileRoute(
  "/staff/rounds_/$roundId/applications_/$applicationId"
)({
  beforeLoad: ({ context, location }) =>
    requireAnySurface(
      context.queryClient,
      ["round_configuration", "intake_operations"],
      location.pathname
    ),
  staticData: {
    breadcrumb: [
      "nav.rounds",
      "breadcrumb.all-rounds",
      "breadcrumb.applications",
      "breadcrumb.dossier",
    ],
  },
  component: DossierDetailRoute,
});

function DossierDetailRoute() {
  const { roundId, applicationId } = Route.useParams();
  return (
    <DossierDetailScreen roundId={roundId} applicationId={applicationId} />
  );
}
